// extracted by mini-css-extract-plugin
export default {"mainContainerStyle":"styles_mainContainerStyle__xH8nD","mainInsideContainerStyle":"styles_mainInsideContainerStyle__aGKCK","aboutContainerStyle":"styles_aboutContainerStyle__gKOBs"};